import React from "react";
import CheckboxField from "../../../../../../components/form-fields/checkbox-field/check-box";

const AddContactsToProjectsColumns = (
  selectedContacts,
  setSelectedContacts
) => {
  return [
    {
      dataKey: "",
      name: "",
      width: "1%",
      align: "left",
      render: (cellData, rowData) => {
        const handleCheckBoxClick = () => {
          const isPresent = selectedContacts.includes(rowData?.id);
          setSelectedContacts((prev) => {
            if (isPresent) {
              return prev.filter((x) => x !== rowData?.id);
            }
            return [...prev, rowData?.id];
          });
        };
        return (
          <div className="checkbox">
            <CheckboxField
              value={selectedContacts.includes(rowData?.id)}
              onChange={handleCheckBoxClick}
            />
          </div>
        );
      },
    },
    {
      dataKey: "name",
      name: "Name",
      width: "40%",
      align: "left",
      // sortable: true,
    },
    {
      dataKey: "title",
      name: "Title",
      width: "40%",
      align: "left",
      // sortable: true,
    },
  ];
};

export default AddContactsToProjectsColumns;
